import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';

// Temporary enum to track features that are enabled for the flowchart editor.
// TODO: Replace with plugin enum
export enum WorkflowFeature {
  /**
   * Enables customizing if a transition will create target tasks based on the number of source tasks
   * (TransitionSource.INPUTS) or outputs (TransitionSource.OUTPUTS), will be used to determine the behavior
   * of the transition in execution. If not enabled, will assume all transitions are TransitionSource.OUTPUTS.
   */
  CUSTOMIZE_TRANSITION_SOURCE = 'customizeTransitionSource',
  /**
   * Enables the use of logic nodes (i.e. router and stop nodes) in the flowchart editor.
   */
  ENABLE_LOGIC_NODES = 'enableLogicNodes',
  /**
   * Allows the user to define additional transitions to be used for execution flexibility.
   *
   * Enables the Transitions tab in the flowchart editor, and allows the user to select if the flowchart
   * will allow at creation modification (ACM) and/or post creation modification (PCM) of the flowchart
   * in execution. The additional transitions will limit what ACM/PCM transitions can be made in execution.
   */
  ALLOW_TRANSITIONS_FOR_EXECUTION_FLEXIBILITY = 'allowTransitionsForExecutionFlexibility',
}

/**
 * Abstract class for defining the behavior of a flowchart editor.
 * Each flowchart editor configurator is responsible for defining which node types are allowed
 * and which features are enabled for the flowchart editor.
 */
export abstract class ProcessFlowchartEditorConfigurator<TFlowchartEditorOptions> {
  constructor(protected readonly options: TFlowchartEditorOptions) {}

  abstract allowedNodeExecutionTypes(): Array<ProcessExecutionType>;

  abstract enabledWorkflowsFeatures(): Array<WorkflowFeature>;

  hasFeature(feature: WorkflowFeature): boolean {
    return this.enabledWorkflowsFeatures().includes(feature);
  }
}
